// Need to use the React-specific entry point to allow generating React hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { setApiKeyHeader } from './fspApi';

import type { Sponsors } from 'types/ApiResponseInterfaces';

// Define a service using a base URL and expected endpoints
export const sponsorsApi = createApi({
  reducerPath: 'sponsorsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_SPONSORS_API_BASE_URL,
    prepareHeaders: setApiKeyHeader(),
  }),
  endpoints: (builder) => ({
    getSponsorsByCompetitionAndPhase: builder.query<Array<Sponsors>, string>({
      query: (competitionAndPhase) => `/v2/sponsors?competitionAndPhase=${competitionAndPhase}&profile=DEFAULT`,
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints

export const { useGetSponsorsByCompetitionAndPhaseQuery } = sponsorsApi;
